import { render, staticRenderFns } from "./FlatDetail.vue?vue&type=template&id=b9761080&scoped=true"
import script from "./FlatDetail.vue?vue&type=script&lang=js"
export * from "./FlatDetail.vue?vue&type=script&lang=js"
import style0 from "./FlatDetail.vue?vue&type=style&index=0&id=b9761080&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9761080",
  null
  
)

export default component.exports